import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from './__root';

export const designRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/design',
  component: lazyRouteComponent(
    () => import('@/screens/DesignSystemScreen'),
    'DesignSystemScreen',
  ),
});
